import { useId } from "react";
import { batteryTone, mugChargePercent } from "./machine";

const TONE_FILL = {
  red: "#d24b4b",
  amber: "#e0a03a",
  emerald: "#307666",
} as const;

type MugBatteryProps = {
  /** 0–1, tied to cup fill. This is not Designer energy. */
  cupFill: number;
};

/**
 * Geometry matches battery-overlay-template.svg (viewBox region 382,621).
 * A 5% red sliver stays visible when the cup is empty so the icon reads
 * as nearly depleted. The accessible value is the real fill, not the sliver.
 */
export default function MugBattery({ cupFill }: MugBatteryProps) {
  const percent = mugChargePercent(cupFill);
  const tone = batteryTone(percent);
  const reactId = useId().replace(/:/g, "");
  const clipId = `mug-battery-${reactId}`;
  const shown = 0.05 + 0.95 * Math.min(1, Math.max(0, cupFill));
  const fillWidth = 306 * shown;

  return (
    <div
      className="mug-battery"
      role="progressbar"
      aria-label="Mug battery"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={percent}
      aria-valuetext={`${percent}% full, ${tone}`}
    >
      <svg viewBox="382 621 382 169" aria-hidden="true" focusable="false">
        <defs>
          <clipPath id={clipId}>
            <rect x="401" y="641" width="306" height="129" rx="8" />
          </clipPath>
        </defs>
        <rect
          x="382"
          y="621"
          width="353"
          height="169"
          rx="25"
          fill="#f6f1ea"
          stroke="#151e1d"
          strokeWidth="16"
        />
        <rect x="735" y="665" width="29" height="83" rx="8" fill="#151e1d" />
        <rect
          x="401"
          y="641"
          width={fillWidth}
          height="129"
          fill={TONE_FILL[tone]}
          clipPath={`url(#${clipId})`}
        />
      </svg>
    </div>
  );
}
